export const toolValidationRules = (values, id) => {
  const errors = {};
  const integerRegex = /^[1-9]\d*$/;

  const name = values.name?.trim() || "";
  const code = values.code?.trim() || "";
  const description = values.description?.trim() || "";
  const totalQuantity = values.totalQuantity;

  if (!name) errors.name = "Name is required";
  else if (name.length < 3) errors.name = "Name must be at least 3 characters";
  if (!id) {
    if (totalQuantity === undefined || totalQuantity === null || totalQuantity === "" || isNaN(totalQuantity))
      errors.totalQuantity = "Quantity is required";
    else if (totalQuantity && !integerRegex.test(totalQuantity)) errors.totalQuantity = "Decimal values are not allowed";
  }
  if (code && code.length < 3) errors.code = "Code must be at least 3 characters";
  if (description && description.length < 3) errors.description = "Description must be at least 3 characters";

  return errors;
};

export const moveToolValidationRules = (values) => {
  const errors = {};

  if (!values.toStoreId) errors.toStoreId = "Please select a store";
  if (!values.movedQuantity) errors.movedQuantity = "Quantity is required";

  return errors;
};

export const updateQuantityValidationRules = (values) => {
  const errors = {};
  const integerRegex = /^[1-9]\d*$/;

  if (!values.storeId) errors.storeId = "Please select a store";
  if (!values.quantity) errors.quantity = "Quantity is required";
  else if (values.quantity && values.quantity <= 0) errors.quantity = "Quantity must be greater than 0";
  else if (values.quantity && !integerRegex.test(values.quantity)) errors.quantity = "Decimal values are not allowed";

  return errors;
};
